import { Id, PagedMultiSelectField, laravelServiceSelectFetchConfig, withOptionsEndpoint } from "@dgs/core";
import { FC } from "react";

const service = withOptionsEndpoint<{ id: Id; name: string }>(["industries"]);

const fetchConfig = laravelServiceSelectFetchConfig(service);

interface Props {
	name: string;
	label: string;
	required?: boolean;
}
export const IndustrySelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
